/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request for batch training data export
 */
export interface BatchTrainingDataRequest {
  /** List of task IDs to export training data for */
  taskIds: string[];
}
